/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { CreatePartnerCreatorResponse, CreatePartnerCreatorVars } from '../openapi-types.gen.js';

export type { CreatePartnerCreatorResponse, CreatePartnerCreatorVars } from '../openapi-types.gen.js';

export const useCreatePartnerCreator = createMutationHook<CreatePartnerCreatorVars, CreatePartnerCreatorResponse, unknown>({
  specName: 'useCreatePartnerCreator',
  path: '/v1/admin/creators',
  method: 'POST',
  resolveUrl: (vars: CreatePartnerCreatorVars) => `/v1/admin/creators`,
  buildBody: (vars: CreatePartnerCreatorVars) => ({ displayName: vars.displayName, handle: vars.handle, avatarUrl: vars.avatarUrl, bannerUrl: vars.bannerUrl, bio: vars.bio, introduction: vars.introduction, website: vars.website, location: vars.location, categories: vars.categories, socialLinks: vars.socialLinks, videoUrl: vars.videoUrl, videoStorageKey: vars.videoStorageKey, email: vars.email, existingUserId: vars.existingUserId }),
  parseResponse: (raw: unknown): CreatePartnerCreatorResponse => raw as CreatePartnerCreatorResponse,
  optimistic: [{
    queryKey: ['admin', 'partner-creators'],
    apply: (prev: any, vars: CreatePartnerCreatorVars) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      return next;
    },
  }, {
    queryKey: ['admin', 'partner-creator'],
    apply: (prev: any, vars: CreatePartnerCreatorVars) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      return next;
    },
  }],
  
  
});
